<template>
  <div class="audio-control horizontal layout" v-if="$store.state.slideActive.audioLink && !isBackstage">
    <audio
      :src="$store.state.slideActive.audioLink.url"
      controls
      preload="auto"
      :loop="$store.state.slideActive.audioRepeat"
      ref="audio-slide-tag"
    />
  </div>
</template>
<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import QuizStatuses from '@/constant/QuizStatuses'
import SlideApi from '@/api/slide'
import utils from '@/util'

export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['isBackstage']),
  },
  watch: {
    '$store.state.slideActive.audioAutoPlay': function (audioAutoPlay) {
      if (audioAutoPlay && this.$store.getters.isPresenting) {
        if (!this.$refs['audio-slide-tag']) return
        this.$refs['audio-slide-tag'].play().catch(() => {})
      }
    },
    '$store.state.slideActive.quizStatus': function (quizStatus) {
      if ((quizStatus == QuizStatuses.COUNTDOWN_5S_SCREEN
        && this.$store.getters.isPresenting && this.$store.state.slideActive.audioAutoPlay)
        || (quizStatus == QuizStatuses.QUESTION_SCREEN && this.$store.getters.isPresenting
        && this.$store.state.slideActive.audioAutoPlay
        && !this.$store.state.presentation.enableQuizCoundown)) {
        if (!this.$refs['audio-slide-tag']) return
        this.$refs['audio-slide-tag'].play().catch(() => {})
      }
    },
    '$store.getters.isPresenting': function () {
      if (this.$store.state.slideActive.audioAutoPlay) {
        if (!this.$refs['audio-slide-tag']) return
        if (!this.$store.getters.isPresenting) {
          this.$refs['audio-slide-tag'].pause()
          return
        }
        if (this.$store.state.slideActive.type == 'pickAnswer') {
          if (this.$store.state.slideActive.quizStatus != QuizStatuses.COUNTDOWN_5S_SCREEN
          || this.$store.state.slideActive.quizStatus != QuizStatuses.QUESTION_SCREEN) {
            return
          }
        }
        if (this.$store.state.slideActive.type === 'spinnerWheel') {
          return
        }
        if (this.$store.getters.isPresenting) {
          this.$refs['audio-slide-tag'].play().catch(() => {})
        }
      } else if (!this.$store.getters.isPresenting) {
        if (!this.$refs['audio-slide-tag']) return
        this.$refs['audio-slide-tag'].pause()
      }
    },

    '$store.state.slideActive.audioVolume': function (audioVolume) {
      if (this.$refs['audio-slide-tag'].audioVolume !== audioVolume) {
        this.$refs['audio-slide-tag'].volume = audioVolume
      }
    },
    '$store.state.slideActive.audioMuted': function (audioMuted) {
      if (this.$refs['audio-slide-tag'].muted !== audioMuted) {
        this.$refs['audio-slide-tag'].muted = audioMuted
      }
    },
  },

  mounted() {
    if (this.$store.state.slideActive.audioAutoPlay || this.$store.state.slideActive.audioAudienceAutoPlay) {
      this.$store.state.slideActive.audioAutoPlay = true
      this.$store.state.slideActive.audioAudienceAutoPlay = true
    }
    setTimeout(() => {
      const elAudio = this.$refs['audio-slide-tag']
      if (elAudio) {
        if (this.$store.state.slideActive.audioVolume) {
          elAudio.volume = this.$store.state.slideActive.audioVolume
        }
        if (this.$store.state.slideActive.audioMuted) {
          elAudio.muted = this.$store.state.slideActive.audioMuted
        }
        elAudio.onvolumechange = () => {
          if (elAudio.muted !== this.$store.state.slideActive.audioMuted) {
            this.updateVolume(elAudio.volume, elAudio.muted)
            return
          }
          if (elAudio.volume === this.$store.state.slideActive.audioVolume) return
          this.updateVolume(elAudio.volume)
        }
      }

      this._playAudio()
      EventBus.$on('stop-audio-slide', () => {
        this._pauseAudio()
      })
    }, 250)
  },
  destroyed() {
    EventBus.$off('stop-audio-slide')
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    updateVolume: _.debounce(function debounceAudioVolume(audioVolume, muted) {
      const payload = {
        audioVolume,
      }
      if (muted !== null) {
        payload.audioMuted = muted
      }
      SlideApi.updateSlideById(this.$store.state.slideActive.id, payload)
      this.updateSlideActiveAction(payload)
      utils.mixpanelTracking('Presentation Editor', 'Slide > Audio > Update Volumne', '')
    }, 300),
    _pauseAudio() {
      if (!this.$refs['audio-slide-tag']) return
      this.$refs['audio-slide-tag'].pause()
    },
    _playAudio() {
      if (this.$store.state.slideActive.type == 'pickAnswer') {
        if (this.$store.state.slideActive.quizStatus != QuizStatuses.COUNTDOWN_5S_SCREEN
        || this.$store.state.slideActive.quizStatus != QuizStatuses.QUESTION_SCREEN) {
          return
        }
      }
      if (this.$store.state.slideActive.type === 'spinnerWheel') {
        return
      }
      setTimeout(() => {
        if (this.$store.state.slideActive.audioAutoPlay && this.$store.getters.isPresenting) {
          if (!this.$refs['audio-slide-tag']) return
          this.$refs['audio-slide-tag'].play().catch(() => {
            this.updateSlideActiveAction({
              audioShowControl: true,
            })
          })
        }
      }, 300)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
</style>
